module.exports = __webpack_public_path__ + "static/media/ft_bg.3be7b4d9.jpg";